import axios from '../../axios';

export default async function getMaintenancePeriodsRepository(): Promise<any[]> {
  let res = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/maintenance/periods`
  );
  return res.data;
}